import type { IUser } from 'interfaces';

let currentUser: IUser | undefined;

const cleanUp = () => {
  currentUser = undefined;
};

export const getUser = (): IUser | undefined => currentUser;

export const setUser = (user: IUser) => {
  currentUser = user;
};

export default {
  getUser,
  setUser,
  cleanUp,
};
